export default {
  REQUEST_UPGRADE: 'Request Upgrade',
}
